module.exports = __webpack_public_path__ + "static/img/独立部署版背景@2x.9c48c1ae.png";